import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from "../../../base.graphql";

export const activateAccount = gql`
  mutation ActivateAccount($input: ActivateAccountInputObject!) {
    activateAccount(input: $input) {
      ${baseResponseGraphqlField}
    }
  }`
